// extracted by mini-css-extract-plugin
export default {"container":"Suite_container__0h4EQ","slide":"Suite_slide__5Bt-r","slideBox":"Suite_slideBox__GpnPo"};